import React from 'react';
import { Button, buttonTypes } from 'moods-react/Button';

import { IconUiTickCircle, IconUiWarningCircle } from 'moods-react/Icons';
import { Spinner, spinnerSizes } from 'moods-react/Spinner';
import Dialog from '../DialogComponent';
import withIframeMessageHub from '../../../../hoc/iframeMessageHub';
import '../DialogButtons.scss';
import './IframeDialogComponent.scss';

function IframeDialogComponent({
  title,
  closeOverlay,
  formUrl,
  email,
  okText,
  cancelText,
  successText,
  failureText,
  submitCallback = () => {},
  getIframeRef,
  postMessage,
  isSuccess,
  isFailure,
  isReady,
}) {
  const close = () => {
    closeOverlay();
  };

  const onIframeLoad = () => {
    postMessage({ email });
  };

  const postSubmitMessage = () => {
    submitCallback();
    postMessage({ submit: true });
  };

  let body;

  if (isSuccess) {
    body = (
      <div className="iframeDialog__feedback">
        <span className="iframeDialog__icon_wrapper">
          <IconUiTickCircle className="iframeDialog__greenicon" />
        </span>
        <span className="iframeDialog__msg" data-dialog-success>
          {successText}
        </span>
      </div>
    );
  } else if (isFailure) {
    body = (
      <div className="iframeDialog__feedback">
        <span className="iframeDialog__icon_wrapper">
          <IconUiWarningCircle className="iframeDialog__redicon" />
        </span>
        <span className="iframeDialog__msg" data-dialog-failure>
          {failureText}
        </span>
      </div>
    );
  } else {
    body = (
      <div className="iframeDialog__main">
        <div className="iframeDialog__overlay" data-dialog-overlay style={{ display: isReady ? 'none' : 'flex' }}>
          <span className="iframeDialog__icon_wrapper" data-dialog-loading>
            <Spinner size={spinnerSizes.MEDIUM} />
          </span>
        </div>
        <iframe ref={getIframeRef} className="iframeDialog__window" src={formUrl} title={title} onLoad={onIframeLoad} />
        <div className="dialog-component__buttons">
          <Button
            data-dialog-cancel
            onClick={close}
            type={buttonTypes.STANDALONE_WHITE}
            data-delete-dialog-cancel
            className="dialog-button"
          >
            {cancelText}
          </Button>
          <Button onClick={postSubmitMessage} data-dialog-ok className="dialog-button">
            {okText}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Dialog title={title} closeOverlay={close}>
      {body}
    </Dialog>
  );
}

export default withIframeMessageHub(IframeDialogComponent);
